<template>
  <v-container class="financial-page financial-overview">
    <v-row class="pa-0 ma-0">
      <v-col cols="12" lg="6" md="12" sm="12" xs="12" class="pa-2">
        <v-row>
          <v-col cols="12" class="overview-col">
            <v-subheader>
              {{ lang.financial.overview.bills }}
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    @click.stop="$router.push({ name: 'financial:page', params: { page: 'contas' }})"
                    color="primary"
                    class="right-pos"
                    icon
                    small
                  >
                    <v-icon>mdi-open-in-new</v-icon>
                  </v-btn>
                </template>
                <span>{{ lang.utils.see_more }}</span>
              </v-tooltip>
            </v-subheader>
            <Periodicals :type="1" />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="6" md="12" sm="12" xs="12" class="pa-2">
        <v-row>
          <v-col cols="12" class="overview-col">
            <v-subheader>
              {{ lang.financial.overview.salary }}
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    @click.stop="$router.push({ name: 'financial:page', params: { page: 'salarios' }})"
                    color="primary"
                    class="right-pos"
                    icon
                    small
                  >
                    <v-icon>mdi-open-in-new</v-icon>
                  </v-btn>
                </template>
                <span>{{ lang.utils.see_more }}</span>
              </v-tooltip>
            </v-subheader>
            <Periodicals :type="2" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0">
      <v-col cols="12" lg="6" md="12" sm="12" xs="12" class="pa-2">
        <v-row>
          <v-col cols="12" class="overview-col">
            <v-subheader>
              {{ lang.financial.cashflow.overview.income }}
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    @click.stop="$router.push({ name: 'financial:page', params: { page: 'fluxo' }})"
                    color="primary"
                    class="right-pos"
                    icon
                    small
                  >
                    <v-icon>mdi-open-in-new</v-icon>
                  </v-btn>
                </template>
                <span>{{ lang.utils.see_more }}</span>
              </v-tooltip>
            </v-subheader>
            <CashFlow :type="1" />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="6" md="12" sm="12" xs="12" class="pa-2">
        <v-row>
          <v-col cols="12" class="overview-col">
            <v-subheader>
              {{ lang.financial.cashflow.overview.expenses }}
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    @click.stop="$router.push({ name: 'financial:page', params: { page: 'fluxo' }})"
                    color="primary"
                    class="right-pos"
                    icon
                    small
                  >
                    <v-icon>mdi-open-in-new</v-icon>
                  </v-btn>
                </template>
                <span>{{ lang.utils.see_more }}</span>
              </v-tooltip>
            </v-subheader>
            <CashFlow :type="2" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Periodicals from './widgets/Periodicals'
import CashFlow from './widgets/CashFlow'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  components: { Periodicals, CashFlow },
  mixins: [ appdata, utils ]
}
</script>

<style src="./styles/index.scss" lang="scss"></style>
